<template>
  <app-header></app-header>
  <section class="wrapper download_page faq Downloads_Tutorials">
    <nav-aside v-show="!isMobile"></nav-aside>
    <router-view></router-view>
  </section>
  <app-footer></app-footer>
</template>
<script>
import AppHeader from '@/components/Header.vue';
import AppFooter from '@/components/Footer.vue';
import NavAside from '@/components/faq/Nav.vue';
export default {
  name: 'FAQ',
  components: {
    'app-header': AppHeader,
    'app-footer': AppFooter,
    'nav-aside': NavAside,
  },
  mounted() {},
  data() {
    return {};
  },
  props: {},
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
  },
  methods: {},
};
</script>

<style lang="scss">
@import '../assets/styles/pages/downloadsTutorials.scss';
</style>
